// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1qp6B","resendInfoText":"OnGoingPaymentBox_resendInfoText__1dGtV"};